<template>
  <q-layout view="lHh Lpr lFf">
    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>

export default {

  components: {
  },

  data() {
    return {
    }
  },
  created() {
    this.$store.dispatch("autoLogin");
  },
}
</script>

<style></style>
